import useAacFlags from "hooks/useAacFlags";
import useTypedContext from "hooks/useTypedContext";
import { SpacesContext } from "views/Account/SpacesProvider";
import { AccountContext } from "views/AccountWrapper";

const useIsOnlySpaceAdmin = () => {
  const { viewer } = useTypedContext(AccountContext);
  const { orgSettingsForSpaceAdmins } = useAacFlags();
  const { hasManageableSpaces } = useTypedContext(SpacesContext);

  return !viewer.admin && orgSettingsForSpaceAdmins && hasManageableSpaces;
};

export default useIsOnlySpaceAdmin;
